import { DateTime } from 'luxon';

import { SessionsQueryQuery as SessionsQuery } from '../documents/SessionsQuery.generated';

export const prepareUpcomingSessions = (rightNow: DateTime) =>
  Object.keys(bareSessionObj())
    .filter((date) => Number(date) >= rightNow.day)
    .reduce((accum, curr) => ({ ...accum, [curr]: {} }), {});

export const bareSessionObj = () =>
  [...Array(31)].reduce((accum, _, idx) => ({ ...accum, [idx + 1]: {} }), {});

export const getEndOfMonth = (dt: DateTime) => dt.endOf('month').endOf('day');
export const getStartOfMonth = (dt: DateTime) => dt.startOf('month').startOf('day');

export const mergeSessions = (existingByDate, updatedSessions: SessionsQuery | undefined) => {
  const sessions = updatedSessions?.providerCoachingVisits?.edges ?? [];

  sessions.forEach((session) => {
    if (session?.node) {
      const { scheduledTime, uuid } = session.node;
      const date = DateTime.fromISO(scheduledTime).day;

      if (existingByDate[date]) {
        existingByDate[date][uuid] = session.node;
      }
    }
  });

  return existingByDate;
};
